var map = {
  "./android.png": "8123",
  "./apple_podcasts.svg": "2559",
  "./castro.svg": "6347",
  "./downcast.svg": "5466",
  "./itunes.svg": "2609",
  "./overcast.png": "3375",
  "./pocket_casts.svg": "172",
  "./spotify.png": "6576"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = function() { return Object.keys(map); };
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 7530;
